import Placeholder from "@tiptap/extension-placeholder";

export const PlaceholderExtension = ({
	placeholder,
	placeholderType,
}: {
	placeholder: string;
	placeholderType?: "first-line" | "full";
}) => {
	return Placeholder.configure({
		placeholder: placeholder,
		emptyNodeClass:
			placeholderType === "first-line"
				? "first-line-placeholder"
				: "is-editor-empty",
		emptyEditorClass:
			placeholderType === "first-line"
				? "first-line-placeholder"
				: "is-editor-empty",
		includeChildren: false,
		showOnlyCurrent: true,
		showOnlyWhenEditable: true,
	});
};
